// Breadcrumb items for prazos pages
export const prazosBreadcrumbItems = [
    {
        label: "Retaguarda",
        url: "#!",
    },
    {
        label: "Cadastros",
        url: "#!",
    },
    {
        label: "Prazos",
        url: "/cadastros/prazos",
        active: true,
    },
];

// Filter state types
export interface ActiveFilters {
    prazoStatus: "active" | "deleted" | "all";
}

export interface FilterState {
    active: ActiveFilters;
    pending: ActiveFilters | null;
    filtersPending: boolean;
}

// Filter options
export const statusOptions = [
    { value: "active", label: "Ativos" },
    { value: "deleted", label: "Inativos" },
    { value: "all", label: "Todos" },
];

// Validation helper
export function validateQuantidadeParcelas(quantidade: number): { isValid: boolean; errorMessage?: string } {
    if (!quantidade || quantidade <= 0) {
        return {
            isValid: false,
            errorMessage: "Quantidade de parcelas deve ser maior que zero"
        };
    }
    
    if (quantidade > 99) {
        return {
            isValid: false,
            errorMessage: "Quantidade de parcelas não pode ser maior que 99"
        };
    }
    
    return { isValid: true };
}